import Axios from '@/components/api/axios.js'
/**********************************************************************************
 * 设备值升接口
 **********************************************************************************/
export default {
	/**
	 * 创建值升配置
	 * variableName:通讯变量名
	 * amplitude:幅度
	 * timeInterval:间隔
	 */
	createGenerallyRise: (variableName, amplitude, timeInterval, success, failure) => {
		Axios.post('/generallyRise/createGenerallyRise.do', {
			variableName,
			amplitude,
			timeInterval,
		}, success, failure);
	},
	/**
	 * 编辑值升配置
	 * pkid
	 * amplitude:幅度
	 * timeInterval:间隔
	 */
	updateGenerallyRise: (pkid, amplitude, timeInterval, success, failure) => {
		Axios.post('/generallyRise/updateGenerallyRise.do', {
			pkid,
			amplitude,
			timeInterval,
		}, success, failure);
	},
	/**
	 * 删除值升配置
	 * pkid
	 */
	deleteGenerallyRise: (pkid, success, failure) => {
		Axios.post('/generallyRise/deleteGenerallyRise.do', {
			pkid,
		}, success, failure);
	},
	/**
	 * 查询值升配置
	 * names:通讯变量名字符串,用逗号隔开
	 */
	searchByGenerallyNames: (names, success, failure) => {
		Axios.post('/generallyRise/searchByGenerallyNames.do', {
			names,
		}, success, failure);
	},
	/**
	 * 批量更新幅度
	 * variableName:通讯变量名,以逗号隔开
	 * amplitude:幅度
	 */
	batchUpdateAmplitude: (variableNames, amplitude, success, failure) => {
		Axios.post('/generallyRise/batchUpdateAmplitude.do', {
			variableNames,
			amplitude,
		}, success, failure);
	},
	/**
	 * 批量更新间隔
	 * variableName:通讯变量名,以逗号隔开
	 * timeInterval:间隔
	 */
	batchUpdateTimeInterval: (variableNames, timeInterval, success, failure) => {
		Axios.post('/generallyRise/batchUpdateTimeInterval.do', {
			variableNames,
			timeInterval,
		}, success, failure);
	},
}